import React from 'react';
import { classNames } from "../../helpers/classNames";

const TitleDecoration = ({ classes, altStyle }) => {
  const data = [
    { _id: 1, classes: altStyle ? "bg-gradient-to-tr from-md-light-yellow to-md-dark-orange animate-decoration-01" : "bg-gradient-to-tr from-md-red to-md-orange animate-decoration-01" },
    { _id: 2, classes: altStyle ? "bg-gradient-to-tr from-md-light-orange to-md-dark-red animate-decoration-02" : "bg-gradient-to-tr from-md-indigo to-md-purple animate-decoration-02" },
    { _id: 3, classes: altStyle ? "bg-gradient-to-tr from-md-light-red to-md-dark-yellow animate-decoration-03" : "bg-gradient-to-tr from-md-green to-md-yellow animate-decoration-03" },
  ]
  return (
    data?.length > 0 && (
      <div className={classNames("flex items-center justify-center gap-1", classes)}>
        {data?.map((item, index) => (
          <div key={index} className={classNames("w-3 rounded-full aspect-square", item?.classes)} />
        ))}
      </div>
    )
  );
};

export default TitleDecoration;